
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.42 13.62a1.15 1.15 0 00-.21-.33l-3-3a1.004 1.004 0 00-1.42 1.42l1.3 1.29H9.5a1 1 0 000 2h5.59l-1.3 1.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l3-3a.93.93 0 00.21-.33 1 1 0 000-.76zM11.5 18h-8a1 1 0 01-1-1V3a1 1 0 011-1h5v3a3 3 0 003 3h4a1 1 0 00.92-.62 1 1 0 00-.21-1.09l-6-6A1.07 1.07 0 009.93.1h-.09L9.56 0H3.5a3 3 0 00-3 3v14a3 3 0 003 3h8a1 1 0 000-2zm-1-14.59L13.09 6H11.5a1 1 0 01-1-1V3.41z","fill":"#fff"}})])
          )
        }
      }
    